module.exports = __webpack_public_path__ + "static/media/117-sun.abf48e44.svg";